exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail[data-v-565eb4b4]{margin-left:20px}.detail .header[data-v-565eb4b4]{margin:20px 0}.detail .basic-message .basic-message-title[data-v-565eb4b4]{margin:20px 0}.detail .basic-message .message div[data-v-565eb4b4]{margin:15px 0}.detail .detail-settle-pagination[data-v-565eb4b4]{margin-top:40px;height:40px;text-align:right}.detail .bottom[data-v-565eb4b4]{width:500px;position:fixed;bottom:20px;left:50%;margin-left:-50px}\n", ""]);

// exports
